import React, { useEffect ,useState} from 'react'
import { getDriverAccepted } from '../../../Api/TaxiServices'
import { errorToast, succToast } from '../../../Toast/Toast'
import { RiseLoader } from 'react-spinners'
import Style from './WaitingDrivers.module.css'
import BurgerMenuTitle from '../../../Component/BurgerMenuTitle/BurgerMenuTitle'
import Timer from '../../../Component/Timer/Timer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/fontawesome-free-solid'
import { userCancelTaxiApi } from '../../../Api/ClientServices'
import { Link, useHistory } from 'react-router-dom'
const WaitingDrivers = () => {
    const [data, setData] =useState()
    const [requestInfoState, setRequestInfoState] =useState()
    const[loadingState,setLoadingState]=useState(false)
    const history=useHistory()
    useEffect(()=>{ 
        driverAccepted()
        setInterval(() => {
            driverAccepted()
        }, 7000);
    },[])

    const driverAccepted= async ()=>{
        getDriverAccepted((succ, res)=>{
            if(succ){
                if(res.status===1){
                    setData(res.request[0].driver)
                    setRequestInfoState(res.request[0])
                }else{
                    errorToast(res.message)
                }
            }else{
                console.error(res)
            }
        })
    }
    const cancelRequestHanlder=()=>{
        setLoadingState(true)
        let info={
            id:requestInfoState.id,
            cause:""
        }
        userCancelTaxiApi(info,(succ,res)=>{
            if(succ){
                if(res.status===0){
                    setLoadingState(false)
                    errorToast(res.message)
                }
                else{
                    succToast("درخواست شما لغو شد!")
                    setLoadingState(false)
                    setTimeout(() => {
                        history.push("/taxireqlist")
                    }, 1000);
                }
            }else{
                console.error(res)
                setLoadingState(false)
            }
        })
    }
    return (
        <div className={Style.componentHolder}>
            <BurgerMenuTitle title="تاکسی"/>
            {
                data&&data.length===0 ? 
                    <div className={Style.noDriver}>
                        <p className={Style.text} >در انتظار تایید راننده</p>
                        <img className={Style.pic} src="/Assets/Images/loading/load.svg" alt=''/>
                        <RiseLoader color="#c20c64" />
                        <button className={Style.cancelRequest} onClick={cancelRequestHanlder} disabled={loadingState}>
                            {loadingState?"لطفا صبرکنید...":"لغو درخواست"}
                        </button>
                    </div>
                :
                    <div className={Style.driverInfo}>
                        <div className={Style.imgHolder}>
                            <img className={Style.img} src={`//cdn.barest.ir/deliver/photo/${data&&data.photo}.jpg`} alt=''/>
                        </div>
                        {/* <Timer Time={data&&Math.round(data.duration)}/> */}
                        <p className={Style.info}>{data?.name}</p>
                        <p className={Style.info}>زمان تقریبی رسیدن: {data&&Math.round(data.duration/60)} دقیقه</p>
                        <a href={`tel:${data?.phone}`} className={Style.info}>{data&&data.phone} <FontAwesomeIcon icon={faPhone}/></a>
                        <p className={Style.info}>{data&&data.vehicle_model} {data&&data.vehicle_color}</p>
                        <p className={Style.info}>{data&&data.vehicle_plate}</p>
                        {/* <p className={Style.info}>موتور</p> */}
                        <p className={Style.info}>{data&&data.vehicle_plate}</p>
                        <Link to={'taxireqlist'} className={Style.cancelRequest}>صفحه درخواست ها</Link>
                    </div>
            }
        </div>
    )
}

export default WaitingDrivers



// import React from 'react'
// import useSWR from 'swr'
// import { getAxiosTotall } from '../../../Api/ApiInstance'

// const fetcher = url => getAxiosTotall.get(url).then(res => res.data)

// const WaitingDrivers = () => {
//     const { data, error } = useSWR('taxi/check_requests/', fetcher)

//     if (error) {
//         return <div>Error fetching data</div>
//     }

//     if (!data) {
//         return <div>Loading...</div>
//     }

//     return <div>{data}</div>
// }

// export default WaitingDrivers
